/**
 * Capitalize first letter of a string
 * @param str
 * @returns
 * @example
 * capitalizeFirstLetter('hello world');
 * // returns 'Hello world'
 */
export var capitalizeFirstLetter = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
